import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {ContinueButton} from "@nolimitcity/slot-launcher/bin/gui/buttons/concretebuttons/ContinueButton";
import {PearlHarbor} from "../PearlHarbor";
import {TimelineLite, TweenLite} from "gsap";
import {PearlHarborGameMode} from "../server/PearlHarborGameMode";
import {PearlHarborSoundManager} from "../sound/PearlHarborSoundManager";
import {PearlHarborGameAssets} from "../PearlHarborGameAssets";
import {BitMapMultiplier} from "./freespin/component/BitMapMultiplier";
import {SpineTween} from "@nolimitcity/slot-game/bin/animation/SpineTween";
import {PearlHarborSoundConfig} from "../sound/PearlHarborSoundConfig";

export class PearlHarborFSIntro extends PIXI.Container implements StageLayer {
    private _overlay:PIXI.Graphics;
    private _mainGameMulti:PIXI.Sprite;
    private _bombMulti:PIXI.Sprite;
    private _bombMultiText:BitMapMultiplier;
    private _scatterMulti:PIXI.Sprite;
    private _spineContainer:PIXI.Sprite;
    private _spine:PIXI.spine.Spine | null;
    private _scatterMultiText:BitMapMultiplier;
    private _title:PIXI.Sprite;
    private _button:ContinueButton;
    private _clickCallback:Function;
    private _idleTimeLine:TimelineLite | null;
    static SPINS_PLAYED_TEXT_STYLE:PIXI.TextStyle = new PIXI.TextStyle({
        fontFamily : "Arial",
        fontWeight : "bold",
        fill : "#ffe18f",
        fontSize : "32px"
    });

    constructor() {
        super();
        this.name = "FS_INTRO_LAYER";
        this.init();
    }

    private init():void {
        this._overlay = new PIXI.Graphics();
        this._scatterMulti = new PIXI.Sprite(PearlHarbor.assetLoader.getTextures("scatterMultiplierFSIntro")[0]);
        this._bombMulti = new PIXI.Sprite(PearlHarbor.assetLoader.getTextures("multBackground")[0]);

        this._mainGameMulti = new PIXI.Sprite();
        this._overlay.alpha = 0;
        this._mainGameMulti.visible = false;
        this.addChild(this._overlay);

        this._spineContainer = new PIXI.Sprite();
        this.addChild(this._spineContainer);
        this._button = new ContinueButton();
        this._button.addClickCallback(() => this.onButtonClick(true));
        this._button.position.set(360, 530);
        this._button.pivot.set(this._button.width * 0.5, 0);
        this._button.enable(false);
        this._button.alpha = 0;

        this._mainGameMulti.position.set(360, 455);
        this.addChild(this._mainGameMulti);

        this._bombMultiText = new BitMapMultiplier(PearlHarborGameAssets.BITMAP_FONT_MULTIPLIER, 30, "x");
        this._bombMulti.addChild(this._bombMultiText);
        this._scatterMultiText = new BitMapMultiplier(PearlHarborGameAssets.BITMAP_FONT_MULTIPLIER, 30, "x");
        this._scatterMulti.addChild(this._scatterMultiText);
        this._bombMulti.position.set(0, 0);
        this._scatterMulti.position.set(0, 0);
        this._bombMulti.anchor.set(1, 0.5);
        this._scatterMulti.anchor.set(0, 0.5);
        this._bombMultiText.position.set(-69, 0);
        this._scatterMultiText.position.set(40, 0);

        this.addChild(this._button);
        this._title = new PIXI.Sprite();
        this._title.anchor.set(0.5);
        this._title.position.set(360, 360);
        this.addChild(this._title);
        this.visible = false;
        this.onResize();
    }

    private onButtonClick(playClickSound:boolean):void {
        this._button.enable(false);
        if(playClickSound) {
            PearlHarborSoundManager.playSoundEffect(PearlHarborSoundConfig.CONTINUE_BUTTON);
        }
        const hideFSIntroTL:TimelineLite = new TimelineLite();
        hideFSIntroTL.add(() => {
            if(this._idleTimeLine) {
                if(this._idleTimeLine.isActive()) {
                    this._idleTimeLine.pause();
                    this._idleTimeLine.kill();
                }
                this._idleTimeLine = null;
            }
            PearlHarbor.keypadPlugin.hide();
        });

        hideFSIntroTL.add([
            new SpineTween(this._spine!, 2, "pressContinue"),
            () => {
                TweenLite.to(this._title.scale, 0.2, {x : 2, y : 2})
                TweenLite.to([this._button, this._title, this._scatterMulti, this._bombMulti], 0.2, {alpha : 0})
                PearlHarbor.cocpitBoard.addMainGameMulti();
                this._clickCallback();
                PearlHarborSoundManager.onFsIntroClose();
            }
        ]);

        hideFSIntroTL.add(() => {
            this.visible = false;
            this._spine = null;
            this._spineContainer.removeChildren();
            this._mainGameMulti.removeChildren();
        });
    }

    public onResize():void {}

    public show(callback:Function, isReplay:boolean):TimelineLite {
        const showFSIntroTL:TimelineLite = new TimelineLite();
        if(this.visible){
            return showFSIntroTL;
        }
        //stop main game idle timeline when entering fs from action spin
        PearlHarbor.foregroundElements.stopIdle();
        PearlHarbor.backgroundElements.stopIdle();
        this.alpha = 0;
        this.visible = true;
        showFSIntroTL.add(() => {
            this._clickCallback = callback;
        });

        const spine:PIXI.spine.Spine = new PIXI.spine.Spine(PearlHarbor.assetLoader.getSpineAsset("FSIntroPearlHarbour"));
        spine.position.set(360, 360);
        this._spineContainer.addChild(spine);
        this._spine = spine;
        if(PearlHarbor.model.gameData && PearlHarbor.model.gameData.brokeBank) {
            this.onButtonClick(false);
        } else {
            const textureName:string = `fsIntro${PearlHarbor.model.data.nextMode === PearlHarborGameMode.SUPER_FREESPIN ? "Tora" : "Dogfight"}`;
            this._title.texture = PearlHarbor.assetLoader.getTextures(textureName)[0];
            this._title.alpha = 1;
            this._button.alpha = 1;
            this._mainGameMulti.alpha = 1;
            this._title.scale.set(0.2);

            const mainGameMulti:number = PearlHarbor.model.dogfight.initialMultFromTrigger;
            let multiNum:number = -1;
            if(mainGameMulti > 1) {
                if(PearlHarbor.model.multiplierNextSpin > 1) {
                    multiNum++;
                    this._bombMulti.visible = true;
                    this._bombMulti.alpha = 1;
                    this._bombMultiText.value = PearlHarbor.model.multiplierNextSpin;
                    this._mainGameMulti.addChild(this._bombMulti);
                }
                if(PearlHarbor.model.scatterMultiplier > 1) {
                    multiNum++;
                    this._scatterMulti.visible = true;
                    this._scatterMulti.alpha = 1;
                    this._scatterMultiText.value = PearlHarbor.model.scatterMultiplier;
                    this._mainGameMulti.addChild(this._scatterMulti);
                }
                this._bombMulti.position.x = ((multiNum === 1) ? -(multiNum * 50) : this._bombMulti.width * 0.5);
                this._scatterMulti.position.x = ((multiNum === 1) ? multiNum * 50 : -this._scatterMulti.width * 0.5);
            }
            this._idleTimeLine = new TimelineLite({paused : true, repeat : 10000, yoyo : true});
            this._idleTimeLine.add(TweenLite.fromTo(this._title.scale, 0.7, {x : 1.5, y : 1.5}, {x : 1, y : 1}));
            showFSIntroTL.add(() => {
                this.alpha = 1;
                if(mainGameMulti > 1) {
                    this._mainGameMulti.visible = true;
                }
            });
            showFSIntroTL.add([
                () => {
                    spine.state.setAnimation(0, "idle", true);
                    PearlHarborSoundManager.onFsIntroShow();
                },
                TweenLite.to(this._title.scale, 0.3, {x : 1.5, y : 1.5}),
                new SpineTween(spine, 1, "dogfightStart")
            ]);

            showFSIntroTL.add([
                () => {
                    if(this._idleTimeLine) {
                        this._idleTimeLine!.play();
                    }
                },
                TweenLite.to(this._button, 0.4, {alpha : 1})
            ]);
            showFSIntroTL.add([
                () => {
                    this._button.enable(true);
                }]);
        }
        return showFSIntroTL;
    }
}